import { supabase } from '../lib/supabase';

export const fetchBookingSlots = async () => {
  const { data } = await supabase
    .from('booking_slots').select('id,booking_date,status').not('status', 'eq', 'cancelled');
  return data || [];
};

export const fetchUserBookings = async (email) => {
  const { data } = await supabase.from('bookings').select('*')
    .eq('client_email', email).order('booking_date', { ascending: false });
  return data || [];
};

export const insertBooking = async (payload) => {
  const { data, error } = await supabase.from('bookings').insert([payload]).select().single();
  if (error) throw error;
  return data;
};

export const updateBookingStatus = async (id, status, extra = {}) => {
  const { error } = await supabase.from('bookings')
    .update({ status, ...extra }).eq('id', id);
  if (error) throw error;
};

export const rescheduleBooking = async (id, newTimestamp) => {
  const { error } = await supabase.from('bookings')
    .update({ booking_date: newTimestamp }).eq('id', id);
  if (error) throw error;
};
